<app-header></app-header>
<main>
  <app-hero></app-hero>
  <app-why-us></app-why-us>
  <app-how-it-works></app-how-it-works>
  <!-- <app-testimonials></app-testimonials> -->
  <section class="testimonials-placeholder text-center" style="padding: 60px 0">
    <h2 class="section-title">Témoignages</h2>
    <p>
      Nous venons de lancer Zero-Waste !<br />
      Il n'y a pas encore de témoignages, mais nous espérons que vous serez
      parmi les premiers à essayer l'application et à partager votre avis.
    </p>
    <span style="font-size: 2.5rem">🚀</span>
  </section>
  <app-download-app></app-download-app>
  <section id="contact-us">
    <zero-waste-contact-us></zero-waste-contact-us>
  </section>
  <app-cta></app-cta>
</main>
<app-footer></app-footer>
<app-cookie-consent />
